export const formatAddress = (address: string, tokenId: number) => {
  if (address) {
    const firstChar = address.substring(0, 4);
    const lastChar = address.substring(address.length - 4);

    return `${firstChar}...${lastChar} #${tokenId}`;
  }

  return '';
};
